import React from "react";
import { Row, Col } from "reactstrap";
import CountUp from "react-countup";
import Widget from "../../../../components/Widget";
import { Progress } from "reactstrap";

const Deployment = () => {

  return (
    <Widget className="hotFix">
      <div className="clearfix relativeDiv">
        <Row className="flex-nowrap">
          <Col xs={3}>
            <img
              src="/icons/deployment.png"
              width={window.innerWidth < 1576 ? "40" : "60"}
            />
          </Col>
          <Col xs={9}>
            <h6 className="m-0">Total Deployment</h6>
            <p className="h2 m-0 fw-normal">
              <CountUp
                start={0}
                end={22579}
                duration={2}
                separator=","
                enableScrollSpy
              />
            </p>
          </Col>
        </Row>
        {/* <Row className="flex-nowrap marginTop36">
          <Col xs="6">
            <h6 className="m-0">Web</h6>
            <p className="value5">
              <CountUp
                start={0}
                end={20686}
                duration={2}
                separator=","
                enableScrollSpy
              />
            </p>
          </Col>
          <Col xs={6}>
            <h6 className="m-0">Tablet</h6>
            <p className="value5">
              <CountUp
                start={0}
                end={1893}
                duration={2}
                separator=","
                enableScrollSpy
              />
            </p>
          </Col>
        </Row> */}
        <Row>
        <div className="" style={{marginTop: "50px"}}>
        <div className="mb-4">
          <div className="clearfix fs-mini">
          <span className="pull-right m-0 fw-semi-bold">
              <CountUp
                start={0}
                end={20686}
                duration={2}
                separator=","
                enableScrollSpy
              />
            </span>
            <span className="fs-mini">{"Web"}</span>
          </div>
          <Progress
            color={"success"}
            className="bg-widget-transparent-lighter progress-xs"
            value={91.6}
          />
        </div>

        <div className="mb-4">
          <div className="clearfix fs-mini">
            <span className="pull-right m-0 fw-semi-bold">
              <CountUp
                start={0}
                end={1893}
                duration={2}
                separator=","
                enableScrollSpy
              />
            </span>
            <span className="fs-mini">{"Tablet"}</span>
          </div>
          <Progress
            color={"success"}
            className="bg-widget-transparent-lighter progress-xs"
            value={8.4}
          />
        </div>

        
      </div>
        </Row>
      </div>
    </Widget>
  );
};

export default Deployment;
